import { Author } from './author';
import { MediaSubject } from './media-subject';

export interface ArticleSummary {
  id: number;
  title: string;
  slug: string;
  subtitle: null | string;
  image: string;
  cover: string;
  caption: null | string;
  author_id: number | null;
  subject_id: number | null;
  author: Author | null;
  magazine?: string;
  subject?: MediaSubject | null;
}

export interface Article {
  id: number;
  title: string;
  slug: string;
  subtitle: null | string;
  image: string;
  cover: string;
  caption: null | string;
  author_id: number | null;
  subject_id: number | null;
  author: Author | null;
  magazine?: string;
  meta_description: string;
  subject?: MediaSubject | null;
}

export interface ArticleMagazine {
  id: number;
  number: number;
  title: string;
}

export interface ArticleHome {
  id: number;
  title: string;
  slug: string;
  subtitle: null | string;
  image: string;
  cover: string;
  caption: null | string;
  author_id: number | null;
  subject_id: number | null;
  author: Author | null;
  magazine?: ArticleMagazine;
  meta_description: string;
  subject?: MediaSubject | null;
}

export class SubjectSection {
  id: number = -1;
  name: string = '';
  slug: string = '';
  cover: string = '';
}
